import PropTypes from 'prop-types';

import MessagesTemplateListItemComponent from '../../MessagesTemplate/ListItem/MessagesTemplateListItemComponent';

import { getFormattedDate } from '../actions';

import { isAdmin, loadUser } from '../../../utils';
import { getFullName } from '../../Person/utils';

const MessageListItemContainer = (props) => {
  const { thread, setCurrentChat, currentChatId, buildings } = props;

  if (!thread?.id) return null;

  const {
    id,
    hasUpdates,
    latestMessage,
    recipient,
    closed,
    messageScope,
    propertyName,
  } = thread;

  const dateFormatter = (date) => getFormattedDate(date);
  const senderName = getFullName(latestMessage?.sender);
  const isCurrentChat = currentChatId === id;
  const isCurrentUserMessage = latestMessage?.sender?.id === loadUser()?.id;

  let isHasUpdatesShown;
  if (!hasUpdates) {
    isHasUpdatesShown = false;
  } else if (hasUpdates && isCurrentChat && isAdmin()) {
    isHasUpdatesShown = true;
  } else if (hasUpdates && !isCurrentChat) {
    isHasUpdatesShown = true;
  } else {
    isHasUpdatesShown = false;
  }

  const buildingName = buildings?.[recipient?.building]?.name;
  const unitName = recipient?.unit && propertyName;

  let fullPropertyName;

  switch (messageScope?.name) {
    case 'Personal':
      if (buildingName && unitName) {
        fullPropertyName = `@ ${buildingName} / ${unitName}`;
      } else if (buildingName) {
        fullPropertyName = `@ ${buildingName}`;
      } else {
        fullPropertyName = propertyName ?? '';
      }
      break;
    default:
      fullPropertyName = [messageScope?.name, propertyName]
        .filter(Boolean)
        .join(' @ ');
  }

  const previewText =
    latestMessage?.text || latestMessage?.document?.name || '';

  const messagePreview = isCurrentUserMessage
    ? `You: ${previewText}`
    : messageScope?.name !== 'Personal' && senderName
    ? `${senderName}: ${previewText}`
    : previewText;

  const recipientInfo = [getFullName(recipient), fullPropertyName]
    .filter(Boolean)
    .join(' ');

  return (
    <MessagesTemplateListItemComponent
      threadId={id}
      photo={recipient?.photo}
      recipientInfo={recipientInfo}
      createdAt={latestMessage?.createdAt}
      messagePreview={messagePreview}
      setCurrentChat={setCurrentChat}
      isCurrentChat={isCurrentChat}
      isClosed={closed}
      isHasUpdatesShown={isHasUpdatesShown}
      dateFormatter={dateFormatter}
    />
  );
};

MessageListItemContainer.defaultProps = {
  thread: {},
  currentChatId: null,
};

MessageListItemContainer.propTypes = {
  thread: PropTypes.instanceOf(Object),
  setCurrentChat: PropTypes.func.isRequired,
  currentChatId: PropTypes.number,
  buildings: PropTypes.instanceOf(Object).isRequired,
};

export default MessageListItemContainer;
